import { createContext, useContext } from "react";
import { BrandUser } from "../../types/brand";

export interface SignInResponse {
  access_token: string;
  refresh_token: string;
  brand: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    profileImage: string;
    shop: string;
    role: "BRAND";
  };
}

interface BrandAuthContextType {
  user: BrandUser | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  version: number;
}

const defaultContextValue: BrandAuthContextType = {
  user: null,
  isAuthenticated: false,
  isLoading: true,
  version: 0,
};

export const BrandAuthContext =
  createContext<BrandAuthContextType>(defaultContextValue);

export const useBrandAuth = () => {
  const context = useContext(BrandAuthContext);
  if (!context) {
    throw new Error("useBrandAuth must be used within a BrandAuthProvider");
  }
  return context;
};
